module.exports = __webpack_public_path__ + "static/media/okay.445811a2.mp3";